import { Component, AfterViewInit, ViewChild, ElementRef } from '@angular/core';
import { GridOptions } from 'ag-grid';
import { Router } from '@angular/router';

import * as encoding from 'encoding-japanese';

import { SalesGroupService } from '../../../service/sales-group/sales-group.service';
import { CommonService } from '../../../service/common/common.service';
import { DialogsService } from '../../../../component/dialog/dialogs.service';
import { environment } from '../../../../environments/environment';
import { config } from '../../../util/config';
import { AgGridHelper } from '../../../util/AgGridHelper';

@Component({
  selector: 'app-wa9163',
  templateUrl: './wa9163.component.html',
  styleUrls: ['./wa9163.component.scss']
})
export class Wa9163Component implements AfterViewInit {
  private gridApi: any;
  public componentTitle = 'WA9163:売上摘要マスタ照会';

  public gridOptions: GridOptions;
  public showGrid: boolean;
  public rowData: any[];

  public ownerId: number;
  public ownerResult: any;
  public config = config;

  private isEnableClearFilter = null;
  private selectedCount = 0;
  public working = false;
  public containerHeight = 500;
  public cardHeight = 500;
  public gridHeight = 500;
  public production = environment.production;
  public backgroundColor: string;
  private errorInfo = '';
  public sales: object = [];

  @ViewChild('gridView')
  private gridView: ElementRef;
  private gridHelper: AgGridHelper;
  private paginationGetRowCount = 0;
  private paginationGetTotalPages = 0;
  private paginationGetCurrentPage = 0;
  private paginationGoToFirstPage;
  private paginationGoToNextPage;
  private isShowLoginModal = false;
  private isShowSendLoading = false;
  public rowsPerPageModel = [{ value: 10, viewValue: '10' }, { value: 20, viewValue: '20' }, { value: 100, viewValue: '100' }, { value: 500, viewValue: '500' }];
  public rowsPerPage = config.rowsPerPageSize;
  private delete: boolean = false;

  constructor(private router: Router, private salesGroupService: SalesGroupService, private commonService: CommonService, private dialogsService: DialogsService) {
    this.gridHelper = new AgGridHelper();
    this.gridHelper.gridSelectionCheckboxStyle = 'radio';
    this.gridOptions = <GridOptions>{
      rowSelection: 'single',
      floatingFilter: true,
      enableRangeSelection: true,
      pagination: true,
      paginationPageSize: this.rowsPerPage,
      localeText: environment.gridLocale,
      getContextMenuItems: this.getContextMenuItems,
      onColumnResized: this.saveColumnWidth,
      onColumnMoved: () => {
        this.saveColumnOrder();
      },
      onGridReady: params => {
        this.gridApi = params;
        const columns = [];
        for (const column of params.columnApi.getAllDisplayedColumns()) {
          const idx = localStorage.getItem(`wa9163_${column.getColId()}_idx`);
          if (idx !== null) {
            columns.push({ idx: parseInt(idx, 10), column: column });
          }
        }
        columns.sort((a, b) => {
          return a.idx - b.idx;
        });
        for (let i = columns.length - 1; i >= 0; i--) {
          const column = columns[i];
          params.columnApi.moveColumn(column.column, column.idx);
        }
        this.gridHelper.onGridReady();
        this.gridHelper.renderGridCheckboxImage();
        this.gridOptions.api.paginationSetPageSize(this.rowsPerPage);
      },
      onFilterChanged: () => {
        this.errorInfo = '';
        this.isEnableClearFilter = this.gridOptions.api.isAnyFilterPresent();
        this.gridHelper.onGridFilterChanged();
      },
      onRowDataChanged: () => {
        this.errorInfo = '';
        this.gridHelper.onRowDataChanged();
        this.selectedCount = 0;
        if (this.gridOptions.rowData && this.gridOptions.rowData.length > 0) this.gridHelper.isShowGridNoDataOverlay = false;
        else this.gridHelper.isShowGridNoDataOverlay = true;
      },
      onSelectionChanged: () => {
        this.errorInfo = '';
        this.selectedCount = this.gridOptions.api.getSelectedRows().length;
      },
      onPaginationChanged: () => {
        this.paginationGetRowCount = this.gridOptions.api.paginationGetRowCount();
        this.paginationGetTotalPages = this.gridOptions.api.paginationGetTotalPages();
        this.paginationGetCurrentPage = this.gridOptions.api.paginationGetCurrentPage() + 1;
        this.gridHelper.renderScrollArrow();
        this.gridHelper.renderGridCheckboxImage();
      },
      postProcessPopup: params => {
        this.errorInfo = '';
        this.gridHelper.fixedAgMenu();
      },
      overlayLoadingTemplate: this.gridHelper.TEMPLATE_GRID_LOADING,
      overlayNoRowsTemplate: this.gridHelper.TEMPLATE_GRID_NODATA
    };
    this.gridOptions.columnDefs = [
      {
        headerName: '',
        headerCheckboxSelection: false,
        headerCheckboxSelectionFilteredOnly: true,
        width: 30,
        checkboxSelection: true,
        suppressSorting: true,
        suppressFilter: true,
        cellClass: ['tc', 'cl_w', 'noCellFocus'],
        pinned: 'left'
      },
      {
        headerName: '売上摘要コード',
        field: 'salesgroupCd',
        sort: 'asc',
        unSortIcon: true,
        cellClass: ['tl', 'cellclass'],
        width: this.getColumnWidth('salesgroupCd', 120)
      },
      {
        headerName: '売上摘要名',
        field: 'salesgroupTx',
        unSortIcon: true,
        cellClass: ['tl', 'cellclass'],
        width: this.getColumnWidth('salesgroupTx', 200)
      },
      {
        headerName: '売上分類コード',
        field: 'salescategoryCd',
        unSortIcon: true,
        cellClass: ['tl', 'cellclass'],
        width: this.getColumnWidth('salescategoryCd', 100)
      },
      {
        headerName: '売上分類名',
        field: 'salescategoryTx',
        unSortIcon: true,
        cellClass: ['tl', 'cellclass'],
        width: this.getColumnWidth('salescategoryTx', 200)
      },
      //fixing the column below
      {
        headerName: '請求書用数量単位名',
        field: 'salesgroupunitTx',
        unSortIcon: true,
        cellClass: ['tl', 'cellclass'],
        width: this.getColumnWidth('salesgroupunitTx', 150)
      },
      {
        headerName: '更新日時',
        field: 'updDt',
        unSortIcon: true,
        cellClass: ['tl', 'cellclass'],
        width: this.getColumnWidth('updDt', 200)
      },
      {
        headerName: '更新者名',
        field: 'upduserTx',
        unSortIcon: true,
        cellClass: ['tl', 'cellclass'],
        width: this.getColumnWidth('upduserTx', 100)
      },
      {
        headerName: '登録日時',
        field: 'addDt',
        unSortIcon: true,
        cellClass: ['tl', 'cellclass'],
        width: this.getColumnWidth('addDt', 200)
      },
      {
        headerName: '登録者名',
        field: 'adduserTx',
        unSortIcon: true,
        cellClass: ['tl', 'cellclass'],
        width: this.getColumnWidth('adduserTx', 100)
      }
    ];
    this.gridHelper.setGridOptions(this.gridOptions);
    this.containerHeight = window.innerHeight - config.containerheaderMargin;
    this.cardHeight = window.innerHeight - config.headerMargin;
    this.gridHeight = window.innerHeight - config.headerMargin - config.containerButtonDubleMargin;
    if (this.production) {
      this.backgroundColor = 'primary';
    } else {
      this.backgroundColor = 'warn';
    }
    this.gridHelper.setGridOptions(this.gridOptions);
  }

  //表示件数の変更
  paginatorRowChange() {
    this.gridOptions.api.paginationSetPageSize(this.rowsPerPage);
    localStorage.setItem('wa9163_rowsPerPage_idx', `${this.rowsPerPage}`);
    this.onSubmit();
  }

  getColumnWidth(id: string, def: number): number {
    return parseInt(localStorage.getItem(`wa9163_${id}_width`), 10) || def;
  }

  saveColumnWidth(params) {
    if (params.finished === true && params.type === 'columnResized') {
      localStorage.setItem(`wa9163_${params.column.colId}_width`, params.column.actualWidth);
    }
  }

  saveColumnOrder() {
    let idx = 0;
    for (const column of this.gridApi.columnApi.getAllDisplayedColumns()) {
      if (column.colId !== '0') {
        localStorage.setItem(`wa9163_${column.colId}_idx`, `${idx}`);
      }
      idx++;
    }
  }

  getContextMenuItems(params) {
    const str_to_unicode_array = str => {
      const arr = [];
      for (let i = 0; i < str.length; i++) {
        arr.push(str.charCodeAt(i));
      }
      return arr;
    };

    const download = csvString => {
      // Unicode コードポイントの配列に変換する
      const unicode_array = str_to_unicode_array(csvString);
      // S-JIS コードポイントの配列に変換
      const sjis_code_array = encoding.convert(
        unicode_array, // ※文字列を直接渡すのではない点に注意
        'SJIS', // to
        'UNICODE' // from
      );
      // 文字コード配列をTypedArrayに変換する
      const uint8_array = new Uint8Array(sjis_code_array);
      // 指定されたデータを保持するBlobを作成する
      const blob = new Blob([uint8_array], { type: 'text/csv' });
      // Internet Explorer
      if (window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(blob, 'export.csv');
      } else {
        // Chrome
        const downloadLink = document.createElement('a');
        downloadLink.href = window.URL.createObjectURL(blob);
        downloadLink.download = 'export.csv';
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
      }
    };

    const result = [
      'copy',
      'copyWithHeaders',
      'separator',
      {
        name: 'エクスポート',
        subMenu: [
          {
            name: 'チェックした行をCSVエクスポート',
            action: () => {
              download(params.api.getDataAsCsv({ onlySelected: true }));
            }
          },
          {
            name: 'すべてCSVエクスポート',
            action: () => {
              download(params.api.getDataAsCsv());
            }
          },
          'excelExport'
        ]
      }
    ];

    return result;
  }

  onResize(event) {
    this.containerHeight = window.innerHeight - config.containerheaderMargin;
    this.cardHeight = window.innerHeight - config.headerMargin;
  }

  onResizeGrid(event) {
    this.gridHeight = event.target.innerHeight - config.headerMargin - config.containerButtonDubleMargin;
  }

  ngAfterViewInit() {
    sessionStorage.removeItem('isShowOwnerSelect');
    this.gridHelper.el = this.gridView;
    setTimeout(() => {
      this.onSubmit();
    }, 500);
  }

  upd() {
    this.errorInfo = '';

    const selectedIndex = this.gridOptions.api.getSelectedNodes()[0]['id'];

    this.sales = this.rowData[selectedIndex];
    sessionStorage.setItem('wa9165openwindow', 'open');
  }

  del() {
    this.isShowSendLoading = true;
    if (this.gridOptions.api.getSelectedNodes().length == 0) {
      return;
    }

    if (this.gridOptions.api.getSelectedNodes().length !== 1) {
      this.errorInfo = '対象を1行だけ選択して下さい';
      this.isShowSendLoading = false;
      //SWMS-1186
      this.delete = false;
      return;
    }

    //SW-2097　ダブルクリック抑止
    if (this.working) return;
    this.working = true;
    const selectedIndex = this.gridOptions.api.getSelectedNodes()[0]['id'];
    const selectedId = this.rowData[selectedIndex]['salesgroupId'];

    this.salesGroupService
      .delete(selectedId)
      .then(outputJson => {
        this.working = false;
        this.onSubmit();
        this.delete = false;
        this.isShowSendLoading = false;
      })
      .catch(error => {
        this.working = false;
        this.errorInfo = this.commonService.getErrorMessage(error);
        this.delete = false;
        this.isShowSendLoading = false;
      });
  }

  onSubmit() {
    //SW-2103　ダブルクリック抑止
    if (this.working) return;
    this.working = true;
    this.gridOptions.api.showLoadingOverlay();
    this.onFilterClear();
    this.salesGroupService
      .get()
      .then(outputJson => {
        this.rowData = outputJson.salesgroups;
        setTimeout(() => {
          this.gridOptions.api.hideOverlay();
          this.working = false;
        },300);
      })
      .catch(error => {
        this.working = false;
        this.gridOptions.api.hideOverlay();
        this.errorInfo = this.commonService.getErrorMessage(error);
      });
  }

  changeOwner(selectedOwnerId) {
    if (selectedOwnerId !== null) {
      if (selectedOwnerId !== undefined) {
        this.rowData = selectedOwnerId;
      } else {
        this.rowData = undefined;
      }
      this.onSubmit();
    } else {
      delete this.rowData;
    }
  }

  onFilterClear() {
    this.gridOptions.api.setFilterModel(null);
  }

  showLoginModal() {
    this.errorInfo = '';
    sessionStorage.removeItem('isShowOwnerSelect');
    this.isShowLoginModal = true;
  }

  onCloseLoginModal(isRefreshGrid: boolean) {
    this.isShowLoginModal = false;
    if (isRefreshGrid) this.onSubmit();
  }
}



// WEBPACK FOOTER //
// /home/runner/work/saas_wms_prod_ui_pc/saas_wms_prod_ui_pc/src/app/pages/wa9Master/wa9163/wa9163.component.ts